import React from 'react';
import { useSelector } from 'react-redux';
import { selectDeviceType } from '../../../redux/selectors';
import { DH } from '../../../utils/DataHook';
import { BoletoModalType, BoletoProps } from './Boleto/types';
import { Loader } from '../../Loader';
import { Modal, Overlay } from '../../ModalLayout';

export const DEFAULT_MODAL_SIZE = {
  modal: {
    width: 580,
    height: 530,
  },
  fullSize: {
    width: '100%',
    height: '100%',
  },
};

export interface BoletoModalViewProps extends BoletoProps {
  width?: number | string;
  height?: number | string;
  isLoading?: boolean;
  component: React.FC<BoletoProps>;
}

export const BoletoModalView: React.FunctionComponent<BoletoModalViewProps> = (
  props
) => {
  const { modalType } = props;
  const deviceType = useSelector(selectDeviceType);

  const defaultSize =
    modalType === BoletoModalType.Standard && deviceType === 'desktop'
      ? DEFAULT_MODAL_SIZE.modal
      : DEFAULT_MODAL_SIZE.fullSize;

  const {
    component: Boleto,
    width = defaultSize.width,
    height = defaultSize.height,
    isLoading,
    boleto,
    onClose,
  } = props;

  return (
    <Overlay dataHook={DH.Boleto.Overlay} onClick={() => onClose()}>
      <Modal width={width} height={height} onClose={() => onClose()}>
        {isLoading ? (
          <Loader />
        ) : (
          <Boleto boleto={boleto} onClose={onClose} modalType={modalType} />
        )}
      </Modal>
    </Overlay>
  );
};
BoletoModalView.displayName = 'BoletoModalView';
